/**
 * Traduções hardcoded de fallback para textos fixos da UI.
 * Usadas pelo GlobalLanguageSwitcher ao salvar uiLanguage no languagePack
 * e pela função t() para lookup direto por componentes.
 *
 * Chave = texto original do componente (PT ou EN).
 *
 * IMPORTANTE: a seção "pt" é obrigatória para sobrescrever traduções ES/EN
 * que ficaram em cache no languagePack ao trocar de idioma.
 */
export const UI_TRANSLATIONS = {
  pt: {
    // Header
    "Change course":  "Trocar curso",
    "FAQ":            "FAQ",
    "Logout":         "Sair",
    "Back":           "Voltar",
    // Home
    "Estas são as aulas disponíveis para você fazer. Escolha uma para começar!":
      "Estas são as aulas disponíveis para você fazer. Escolha uma para começar!",
    "Carregando cursos...": "Carregando cursos...",
    // LessonLoader
    "Carregando aula...": "Carregando aula...",
    "Loading lesson...":  "Carregando aula...",
    "Carregando...":      "Carregando...",
    "Loading...":         "Carregando...",
    // Footer / KeepPlaying
    "Auto Play":          "Auto Play",
    "Tempo de Intervalo": "Tempo de Intervalo",
    // InstantFeedback
    "Ajude-nos a melhorar sua experiência!":    "Ajude-nos a melhorar sua experiência!",
    "Como é sua experiência com o Catchup?":    "Como é sua experiência com o Catchup?",
    "BOM":                   "BOM",
    "RUIM":                  "RUIM",
    "Obrigado por avaliar!": "Obrigado por avaliar!",
    // EndLesson
    "Continue Praticando!": "Continue Praticando!",
    "Agora que você terminou, aproveite o restante da sua aula para continuar fazendo mais exercícios no Wiz.me.":
      "Agora que você terminou, aproveite o restante da sua aula para continuar fazendo mais exercícios no Wiz.me.",
    "Voltar para lessons":       "Voltar para lições",
    "Acessar exercícios online": "Acessar exercícios online",
    // NoContentLesson
    "Oops! Parece que essa atividade não está disponível para você.":
      "Oops! Parece que essa atividade não está disponível para você.",
    "Volte para lista de lições ou clique em Pular para continuar seus estudos.":
      "Volte para lista de lições ou clique em Pular para continuar seus estudos.",
    "Pular": "Pular",
    // Templates – instruções fixas
    "Tap on the card, listen, and speak.":           "Toque no cartão, ouça e fale.",
    "Tap on the card, listen, and speak in English.":"Toque no cartão, ouça e fale em inglês.",
    "Tap the image to see the word":                 "Toque na imagem para ver a palavra",
    "Tap the image to see the sentence.":            "Toque na imagem para ver a frase.",
    "Listen to the Audio.":                          "Ouça o Áudio.",
    "Match the pictures to the sentences.":          "Associe as imagens às frases.",
    "Make the correct Matching":                     "Faça a combinação correta",
    "Drag vertically to put in order.":              "Arraste verticalmente para ordenar.",
    "Fill in the blanks with the appropriate words.":"Preencha as lacunas com as palavras corretas.",
    "Dialogue Practice":                             "Prática de Diálogo",
    "Muito Bem!":                                    "Muito Bem!",
    // Microphone / voice recognition
    "Continue":                                      "Continuar",
    "No speech detected, please try again!":         "Nenhuma fala detectada, tente novamente!",
    "A problem with audio was detected, please try again late!": "Um problema de áudio foi detectado, tente novamente mais tarde!",
    "The limit of 3 attempts has been exceeded.":    "O limite de 3 tentativas foi excedido.",
    // Banner / Cards
    "You haven't finished any lessons":              "Você ainda não concluiu nenhuma aula",
    "Congratulations! You have completed all your lessons!": "Parabéns! Você concluiu todas as suas aulas!",
    "Courses":   "Cursos",
    "Start Now": "Começar agora",
    "Completed": "Concluído",
    // Lessons list / Navigation
    "Home":            "Início",
    "Lessons":         "Lições",
    "Start Lesson":    "Iniciar Aula",
    "No lessons available.": "Nenhuma aula disponível.",
    // Error page
    "An authentication error occurred.": "Ocorreu um erro de autenticação.",
    "Try Again":       "Tentar novamente",
    // Templates – misc
    "Model":           "Modelo",
    "Instruction":     "Instrução",
    "No video available": "Vídeo não disponível",
    "Click to Repeat": "Clique para repetir",
  },
  en: {
    // Header
    "Change course":  "Change course",
    "FAQ":            "FAQ",
    "Logout":         "Logout",
    "Back":           "Back",
    // Home
    "Estas são as aulas disponíveis para você fazer. Escolha uma para começar!":
      "These are the classes available for you. Choose one to start!",
    "Carregando cursos...": "Loading courses...",
    // LessonLoader
    "Carregando aula...": "Loading lesson...",
    "Loading lesson...":  "Loading lesson...",
    "Carregando...":      "Loading...",
    "Loading...":         "Loading...",
    // Footer / KeepPlaying
    "Auto Play":          "Auto Play",
    "Tempo de Intervalo": "Interval Time",
    // InstantFeedback
    "Ajude-nos a melhorar sua experiência!":    "Help us improve your experience!",
    "Como é sua experiência com o Catchup?":    "How is your experience with Catchup?",
    "BOM":                   "GOOD",
    "RUIM":                  "BAD",
    "Obrigado por avaliar!": "Thank you for rating!",
    // EndLesson
    "Continue Praticando!": "Keep Practicing!",
    "Agora que você terminou, aproveite o restante da sua aula para continuar fazendo mais exercícios no Wiz.me.":
      "Now that you're done, take advantage of the rest of your class to continue doing more exercises on Wiz.me.",
    "Voltar para lessons":       "Back to lessons",
    "Acessar exercícios online": "Access online exercises",
    // NoContentLesson
    "Oops! Parece que essa atividade não está disponível para você.":
      "Oops! This activity is not available for you.",
    "Volte para lista de lições ou clique em Pular para continuar seus estudos.":
      "Go back to the lessons list or click Skip to continue your studies.",
    "Pular": "Skip",
    // Templates – instruções fixas
    "Tap on the card, listen, and speak.":           "Tap on the card, listen, and speak.",
    "Tap on the card, listen, and speak in English.":"Tap on the card, listen, and speak in English.",
    "Tap the image to see the word":                 "Tap the image to see the word",
    "Tap the image to see the sentence.":            "Tap the image to see the sentence.",
    "Listen to the Audio.":                          "Listen to the Audio.",
    "Match the pictures to the sentences.":          "Match the pictures to the sentences.",
    "Make the correct Matching":                     "Make the correct Matching",
    "Drag vertically to put in order.":              "Drag vertically to put in order.",
    "Fill in the blanks with the appropriate words.":"Fill in the blanks with the appropriate words.",
    "Dialogue Practice":                             "Dialogue Practice",
    "Muito Bem!":                                    "Well done!",
    // Microphone / voice recognition
    "Continue":                                      "Continue",
    "No speech detected, please try again!":         "No speech detected, please try again!",
    "A problem with audio was detected, please try again late!": "A problem with audio was detected, please try again later!",
    "The limit of 3 attempts has been exceeded.":    "The limit of 3 attempts has been exceeded.",
    // Banner / Cards
    "You haven't finished any lessons":              "You haven't finished any lessons",
    "Congratulations! You have completed all your lessons!": "Congratulations! You have completed all your lessons!",
    "Courses":   "Courses",
    "Start Now": "Start Now",
    "Completed": "Completed",
    // Lessons list / Navigation
    "Home":            "Home",
    "Lessons":         "Lessons",
    "Start Lesson":    "Start Lesson",
    "No lessons available.": "No lessons available.",
    // Error page
    "An authentication error occurred.": "An authentication error occurred.",
    "Try Again":       "Try Again",
    // Templates – misc
    "Model":           "Model",
    "Instruction":     "Instruction",
    "No video available": "No video available",
    "Click to Repeat": "Click to Repeat",
  },
  es: {
    // Header
    "Change course":  "Cambiar curso",
    "FAQ":            "FAQ",
    "Logout":         "Cerrar sesión",
    "Back":           "Volver",
    // Home
    "Estas são as aulas disponíveis para você fazer. Escolha uma para começar!":
      "Estas son las clases disponibles para ti. ¡Elige una para comenzar!",
    "Carregando cursos...": "Cargando cursos...",
    // LessonLoader
    "Carregando aula...": "Cargando lección...",
    "Loading lesson...":  "Cargando lección...",
    "Carregando...":      "Cargando...",
    "Loading...":         "Cargando...",
    // Footer / KeepPlaying
    "Auto Play":          "Reproducción automática",
    "Tempo de Intervalo": "Tiempo de Intervalo",
    // InstantFeedback
    "Ajude-nos a melhorar sua experiência!":    "¡Ayúdanos a mejorar tu experiencia!",
    "Como é sua experiência com o Catchup?":    "¿Cómo es tu experiencia con Catchup?",
    "BOM":                   "BUENO",
    "RUIM":                  "MALO",
    "Obrigado por avaliar!": "¡Gracias por evaluar!",
    // EndLesson
    "Continue Praticando!": "¡Sigue Practicando!",
    "Agora que você terminou, aproveite o restante da sua aula para continuar fazendo mais exercícios no Wiz.me.":
      "Ahora que terminaste, aprovecha el resto de tu clase para hacer más ejercicios en Wiz.me.",
    "Voltar para lessons":       "Volver a lecciones",
    "Acessar exercícios online": "Acceder a ejercicios en línea",
    // NoContentLesson
    "Oops! Parece que essa atividade não está disponível para você.":
      "¡Ups! Esta actividad no está disponible para ti.",
    "Volte para lista de lições ou clique em Pular para continuar seus estudos.":
      "Vuelve a la lista de lecciones o haz clic en Saltar para continuar tus estudios.",
    "Pular": "Saltar",
    // Templates – instruções fixas
    "Tap on the card, listen, and speak.":           "Toca la tarjeta, escucha y habla.",
    "Tap on the card, listen, and speak in English.":"Toca la tarjeta, escucha y habla en inglés.",
    "Tap the image to see the word":                 "Toca la imagen para ver la palabra",
    "Tap the image to see the sentence.":            "Toca la imagen para ver la frase.",
    "Listen to the Audio.":                          "Escucha el Audio.",
    "Match the pictures to the sentences.":          "Relaciona las imágenes con las frases.",
    "Make the correct Matching":                     "Haz la combinación correcta",
    "Drag vertically to put in order.":              "Arrastra verticalmente para ordenar.",
    "Fill in the blanks with the appropriate words.":"Completa los espacios con las palabras correctas.",
    "Dialogue Practice":                             "Práctica de Diálogo",
    "Muito Bem!":                                    "¡Muy bien!",
    // Microphone / voice recognition
    "Continue":                                      "Continuar",
    "No speech detected, please try again!":         "¡No se detectó voz, inténtalo de nuevo!",
    "A problem with audio was detected, please try again late!": "¡Se detectó un problema de audio, inténtalo más tarde!",
    "The limit of 3 attempts has been exceeded.":    "Se superó el límite de 3 intentos.",
    // Banner / Cards
    "You haven't finished any lessons":              "Aún no has completado ninguna lección",
    "Congratulations! You have completed all your lessons!": "¡Felicitaciones! ¡Completaste todas tus lecciones!",
    "Courses":   "Cursos",
    "Start Now": "Comenzar ahora",
    "Completed": "Completado",
    // Lessons list / Navigation
    "Home":            "Inicio",
    "Lessons":         "Lecciones",
    "Start Lesson":    "Iniciar Lección",
    "No lessons available.": "No hay lecciones disponibles.",
    // Error page
    "An authentication error occurred.": "Ocurrió un error de autenticación.",
    "Try Again":       "Intentar de nuevo",
    // Templates – misc
    "Model":           "Modelo",
    "Instruction":     "Instrucción",
    "No video available": "Video no disponible",
    "Click to Repeat": "Haz clic para repetir",
  },
};

/**
 * Traduz uma chave usando uiLanguage do languagePack.
 * Fallback: TaaS (pack[key]) → chave original.
 */
export function t(key) {
  try {
    const raw = localStorage.getItem("languagePack");
    const pack = raw ? JSON.parse(raw) : {};
    const uiLang = (pack.uiLanguage || "").substring(0, 2).toLowerCase();
    if (uiLang && UI_TRANSLATIONS[uiLang] && UI_TRANSLATIONS[uiLang][key] !== undefined) {
      return UI_TRANSLATIONS[uiLang][key];
    }
    if (pack[key]) return pack[key];
  } catch (e) {}
  return key;
}

/**
 * Retorna o idioma de UI atual (2 letras, ex: "pt", "en", "es").
 */
export function getUiLang() {
  try {
    const pack = JSON.parse(localStorage.getItem("languagePack") || "{}");
    return (pack.uiLanguage || "pt").substring(0, 2).toLowerCase();
  } catch (e) {
    return "pt";
  }
}
